import { Progress, Select, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import CustomTable from "./CustomTable";
import "./ProgressTable.css";
import { useSelector } from "react-redux";
import AwsAxios from "../../utils/AwsAxios";
import Coursera from "../../utils/courseraAxiosConfig";
import { getAttemptAssessmentData } from "../../services/awsServices";

const TableWithProgress = () => {
  const email = localStorage?.getItem("username");
  const [courses, setCourses] = useState();
  const [attemptedAssesment, setAttemptedAssesment] = useState();

  console.log({ email });

  const asyncFetch = async () => {
    try {
      const response = await Coursera.get(
        `https://7q63conwve.execute-api.us-east-2.amazonaws.com/Prod/enrollment/${email}`
      );
      if (response && response.data) {
        const apiData = response.data;
        // Assuming the structure of apiData is correct as you described
        console.log(apiData, "datafromCoursesEmail");
        setCourses(apiData);
      }
    } catch (error) {
      console.error("Fetch data failed", error);
    }
  };
  const getAttemptedResults = async () => {
    const ids = [];
    try {
      if (email) {
        const res = await getAttemptAssessmentData(email);
        console.log(res, "adasdad");
        if (res && res.data) {
          const assesmentData = res.data.data.testInstances.map((data) => ({
            status: data.testStatus.status,
            name: data.assessmentName,
            category: "Assesment",
            date: data.testStatus.startTime,
          }));

          setAttemptedAssesment(assesmentData);
        }
      }
    } catch (error) {
      console.log(error);
    }

    // setAttemptedId(ids);
  };

  useEffect(() => {
    getAttemptedResults();
    asyncFetch();
  }, []);

  console.log({ attemptedAssesment });
  const { TabPane } = Tabs;

  const columns = [
    {
      title: `Name`,
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a?.name?.length - b?.name?.length,
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      // sorter: (a, b) => a?.category?.length - b?.category?.length,
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      // sorter: (a, b) => a?.date?.date - b?.date?.date,
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      // sorter: (a, b) => a?.course?.length - b?.course?.length,
      sortDirections: ["descend", "ascend"],
    },
  ];

  const data = [
    {
      key: "1",
      course: "Marketplace",
      category: "Accounting",
      instructor: "Ali",
      progress: 60,
    },
    {
      key: "1",
      course: "Venus Dashboard Builder",
      category: "Accounting",
      instructor: "Husnain",
      progress: 50,
    },
    {
      key: "1",
      course: "Venus Design System",
      category: "Accounting",
      instructor: "Muh",
      progress: 70,
    },
    {
      key: "1",
      course: "Uranus",
      category: "Accounting",
      instructor: "Alqama",
      progress: 20,
    },
    // ...more data
  ];

  return (
    <div className="TableWithProgress rounded-2xl p-5 shadow-shadowOne bg-pureWhite overflow-auto h-full">
      <div className="flex justify-between items-center">
        <h1 className="font-semibold text-lg">Recent Activity</h1>
        {/* <Select
          defaultValue="recent activity"
          style={{ width: 120 }}
          // onChange={handleChange}
          // options={[
          //   { value: "courses", label: "Courses" },
          //   { value: "assessment", label: "Assessment" },
          // ]}
        /> */}
      </div>
      <CustomTable
        columns={columns}
        data={attemptedAssesment}
        pagination={false}
      />
    </div>
  );
};

export default TableWithProgress;
